import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { MDText } from 'i18n-react';
import LinkedEntitiesCellBlock from '../../LinkedEntitiesCellBlock';
import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';
import { ENVS, REGIONS } from '@adsk/bim360-matrix-react-helpers/es/consts';
import getEnvConfig from './helpers/getEnvConfig';
import { ISSUES_ENV_CONFIG_KEYS, statusColorMapping } from './consts';

const IssueLinkedEntitiesCellBlock = ({ entity, env, region, projectId, ...props }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  const { id, status, title, displayId } = entity;
  const statusColor = status ? statusColorMapping[status] : null;
  const statusTextKey = status ? status.toUpperCase() : null;
  const statusText = statusTextKey ? T.translate(statusTextKey) : null;
  const deeplinkUrl = `${getEnvConfig(
    env,
    region,
    ISSUES_ENV_CONFIG_KEYS.DOCS_FE
  )}/projects/${projectId}/issues/${id}`;
  return (
    <LinkedEntitiesCellBlock
      {...props}
      entityTypeName={T.translate('ISSUE')}
      title={title}
      userFriendlyId={displayId ? `#${displayId}` : displayId}
      deeplinkUrl={deeplinkUrl}
      statusColor={statusColor}
      statusText={statusText}
    />
  );
};

IssueLinkedEntitiesCellBlock.propTypes = {
  /**
   * The RF entity we need to render.
   */
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    displayId: PropTypes.number.isRequired
  }).isRequired,
  /**
   * The environment. One of `ENVS` values.
   */
  env: PropTypes.oneOf(objectValues(ENVS)).isRequired,
  /**
   * The region. One of `REGIONS` values.
   */
  region: PropTypes.oneOf(objectValues(REGIONS)).isRequired,
  /**
   * The project ID
   */
  projectId: PropTypes.string.isRequired
};

export default IssueLinkedEntitiesCellBlock;
